var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.availableSites,"hide-selected":"","loading":_vm.sitesLoading,"outlined":"","dense":"","hide-details":"","item-text":"name","item-value":"id"},on:{"change":_vm.emitNewValue},model:{value:(_vm.localSelection),callback:function ($$v) {_vm.localSelection=$$v},expression:"localSelection"}})
}
var staticRenderFns = []

export { render, staticRenderFns }